module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("PCS 06 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MSG Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "MSG_NAME",
      "name": "MSG_NAME"
    },
    model: {
      value: (_vm.MSG_NAME),
      callback: function($$v) {
        _vm.MSG_NAME = $$v
      },
      expression: "MSG_NAME"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MSG IDENTIFIER (KOCU4351870)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "MSG_IDENTIFIER",
      "name": "MSG_IDENTIFIER"
    },
    model: {
      value: (_vm.MSG_IDENTIFIER),
      callback: function($$v) {
        _vm.MSG_IDENTIFIER = $$v
      },
      expression: "MSG_IDENTIFIER"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.MSG_NAME && _vm.MSG_IDENTIFIER) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.getAllPCS06Func()
      }
    }
  }, [_vm._v("Fetch")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.getAllPcs06 ||
    !_vm.getAllPcs06.response ||
    _vm.getAllPcs06.response.map.Description ||
    _vm.getAllPcs06.responseStatus === 'not found'
  ) ? _c('div', [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("No data found."))])]) : _c('div', [_c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Gross Quantity:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .GrossQtyVolume) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Seal No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SealNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("No of Packages:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .NoofPackages) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("SMTP Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SMTPDate) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Container Type:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .ContainerType) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Destination Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .DestinationCode) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Customs House Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .CustomsHouseCode) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Bond No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.BondNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Container No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .ContainerNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Cargo Description:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.CargoDesc) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .LineNumber) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Unit of Packages:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .UnitofPackages) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("IGM Date:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.IGMDate) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("SMTP No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SMTPNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Consignee Name:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .ConsigneeName) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("IGM No:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.IGMNo) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Sub Line Number:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .SubLineNumber) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Carrier Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .CarrierCode) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Terminal Operator Code:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .TerminalOperatorCode) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Unit of Quantity:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.UnitofQty) + "\n        ")]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Message Type:")]), _vm._v("\n          " + _vm._s(_vm.getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
    .MessageType) + "\n        ")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c82c31e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/PCS06_ResponseDisplay.vue
// module id = 2813
// module chunks = 0